import type { SVGProps } from "react";
export default function SvgBenchmarkApp(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="1em"
			height="1em"
			fill="none"
			viewBox="0 0 165 188"
			{...props}
		>
			<foreignObject width={155.626} height={183.626} x={0} y={4.37402}>
				<div
					style={{
						backdropFilter: "blur(9px)",
						clipPath: "url(#bgblur_0_1094_1380_clip_path)",
						height: "100%",
						width: "100%",
					}}
				/>
			</foreignObject>
			<g data-figma-bg-blur-radius={18} filter="url(#filter0_ddddi_1094_1380)">
				<path
					fill="url(#paint0_linear_1094_1380)"
					fillOpacity={0.6}
					d="M115.626 60.187c0-20.884-16.93-37.813-37.813-37.813S40 39.304 40 60.187 56.93 98 77.813 98s37.813-16.93 37.813-37.813"
				/>
				<path
					stroke="url(#paint1_linear_1094_1380)"
					d="M77.814 22.874c20.607 0 37.312 16.706 37.312 37.313S98.421 97.5 77.814 97.5C57.206 97.5 40.5 80.794 40.5 60.187s16.706-37.313 37.314-37.313Z"
				/>
			</g>
			<foreignObject width={125.934} height={153.934} x={38.8027} y={-4}>
				<div
					style={{
						backdropFilter: "blur(9px)",
						clipPath: "url(#bgblur_1_1094_1380_clip_path)",
						height: "100%",
						width: "100%",
					}}
				/>
			</foreignObject>
			<g data-figma-bg-blur-radius={18} filter="url(#filter1_ddddi_1094_1380)">
				<path
					fill="white"
					fillOpacity={0.01}
					d="M78.803 56.755V17.182c0-1.88 1.618-3.315 3.492-3.172a46.08 46.08 0 0 1 29.074 13.357 46.1 46.1 0 0 1 13.358 29.074c.143 1.874-1.296 3.492-3.173 3.492H81.981a3.176 3.176 0 0 1-3.175-3.175z"
				/>
				<path
					stroke="url(#paint2_linear_1094_1380)"
					strokeOpacity={0.5}
					d="m79.306 56.55-.003-.002V17.183c0-1.575 1.357-2.796 2.954-2.674a45.6 45.6 0 0 1 28.759 13.212 45.6 45.6 0 0 1 13.212 28.759c.121 1.596-1.102 2.954-2.674 2.954H81.981a2.676 2.676 0 0 1-2.675-2.676z"
				/>
			</g>
			<path
				fill="#FAFF00"
				d="M78.628 59.117V48.074c0-.525.452-.926.975-.886a12.86 12.86 0 0 1 8.114 3.728 12.86 12.86 0 0 1 3.727 8.114.896.896 0 0 1-.885.974H79.515a.89.89 0 0 1-.887-.887"
			/>
			<defs>
				<linearGradient
					id="paint0_linear_1094_1380"
					x1={78.0059}
					x2={78.0059}
					y1={22.374}
					y2={97.9996}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#F5FCFF" />
					<stop offset={1} stopColor="#BBD3DD" />
				</linearGradient>
				<linearGradient
					id="paint1_linear_1094_1380"
					x1={77.8131}
					x2={49.89}
					y1={23.2022}
					y2={85.2562}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="white" />
					<stop offset={0.519231} stopColor="#A6BEC4" />
					<stop offset={1} stopColor="white" />
				</linearGradient>
				<linearGradient
					id="paint2_linear_1094_1380"
					x1={101.77}
					x2={101.77}
					y1={14}
					y2={59.9333}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#F5FCFF" />
					<stop offset={0.509653} stopColor="#B1D2DB" />
					<stop offset={1} stopColor="#F5FCFF" />
				</linearGradient>
				<clipPath id="bgblur_0_1094_1380_clip_path" transform="translate(0 -4.374)">
					<path d="M115.626 60.187c0-20.884-16.93-37.813-37.813-37.813S40 39.304 40 60.187 56.93 98 77.813 98s37.813-16.93 37.813-37.813" />
				</clipPath>
				<clipPath id="bgblur_1_1094_1380_clip_path" transform="translate(-38.803 4)">
					<path d="M78.803 56.755V17.182c0-1.88 1.618-3.315 3.492-3.172a46.08 46.08 0 0 1 29.074 13.357 46.1 46.1 0 0 1 13.358 29.074c.143 1.874-1.296 3.492-3.173 3.492H81.981a3.176 3.176 0 0 1-3.175-3.175z" />
				</clipPath>
				<filter
					id="filter0_ddddi_1094_1380"
					width={155.626}
					height={183.626}
					x={0}
					y={4.37402}
					colorInterpolationFilters="sRGB"
					filterUnits="userSpaceOnUse"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={10} />
					<feGaussianBlur stdDeviation={12} />
					<feColorMatrix values="0 0 0 0 0.419608 0 0 0 0 0.658824 0 0 0 0 0.717647 0 0 0 0.1 0" />
					<feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1094_1380" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={40} />
					<feGaussianBlur stdDeviation={20} />
					<feColorMatrix values="0 0 0 0 0.419608 0 0 0 0 0.658824 0 0 0 0 0.717647 0 0 0 0.09 0" />
					<feBlend
						in2="effect1_dropShadow_1094_1380"
						result="effect2_dropShadow_1094_1380"
					/>
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={50} />
					<feGaussianBlur stdDeviation={15} />
					<feColorMatrix values="0 0 0 0 0.0620791 0 0 0 0 0.165757 0 0 0 0 0.220065 0 0 0 0.02 0" />
					<feBlend
						in2="effect2_dropShadow_1094_1380"
						result="effect3_dropShadow_1094_1380"
					/>
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={50} />
					<feGaussianBlur stdDeviation={20} />
					<feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0" />
					<feBlend
						in2="effect3_dropShadow_1094_1380"
						result="effect4_dropShadow_1094_1380"
					/>
					<feBlend in="SourceGraphic" in2="effect4_dropShadow_1094_1380" result="shape" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={-1} />
					<feGaussianBlur stdDeviation={2.5} />
					<feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
					<feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
					<feBlend in2="shape" result="effect5_innerShadow_1094_1380" />
				</filter>
				<filter
					id="filter1_ddddi_1094_1380"
					width={125.934}
					height={153.934}
					x={38.8027}
					y={-4}
					colorInterpolationFilters="sRGB"
					filterUnits="userSpaceOnUse"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={10} />
					<feGaussianBlur stdDeviation={12} />
					<feColorMatrix values="0 0 0 0 0.419608 0 0 0 0 0.658824 0 0 0 0 0.717647 0 0 0 0.1 0" />
					<feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1094_1380" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={40} />
					<feGaussianBlur stdDeviation={20} />
					<feColorMatrix values="0 0 0 0 0.419608 0 0 0 0 0.658824 0 0 0 0 0.717647 0 0 0 0.09 0" />
					<feBlend
						in2="effect1_dropShadow_1094_1380"
						result="effect2_dropShadow_1094_1380"
					/>
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={50} />
					<feGaussianBlur stdDeviation={15} />
					<feColorMatrix values="0 0 0 0 0.0620791 0 0 0 0 0.165757 0 0 0 0 0.220065 0 0 0 0.02 0" />
					<feBlend
						in2="effect2_dropShadow_1094_1380"
						result="effect3_dropShadow_1094_1380"
					/>
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={50} />
					<feGaussianBlur stdDeviation={20} />
					<feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0" />
					<feBlend
						in2="effect3_dropShadow_1094_1380"
						result="effect4_dropShadow_1094_1380"
					/>
					<feBlend in="SourceGraphic" in2="effect4_dropShadow_1094_1380" result="shape" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={-1} />
					<feGaussianBlur stdDeviation={2.5} />
					<feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
					<feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
					<feBlend in2="shape" result="effect5_innerShadow_1094_1380" />
				</filter>
			</defs>
		</svg>
	);
}
